import { SubjectRole } from "../generated/graphql"

const RolesUiDisplayObj = {
    [SubjectRole.OrgAdmin]: "Organization Admin",
    [SubjectRole.OrgMember]: "Organization Member",
    [SubjectRole.PpoAdmin]: "PPO Admin",
    [SubjectRole.Unknown]: "Unknown",
    [SubjectRole.System]: "System",
} as const

export { RolesUiDisplayObj }
